import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://ostelo.fr";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag || "meta");
    Object.entries(attrs.static || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs.set).forEach(([k, v]) => el.setAttribute(k, v));
};

export const Seo = ({ title, description, lang }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    upsert('meta[name="description"]', { static: { name: "description" }, set: { content: description } });
    upsert('meta[property="og:title"]', { static: { property: "og:title" }, set: { content: title } });
    upsert('meta[property="og:description"]', { static: { property: "og:description" }, set: { content: description } });
    upsert('meta[property="og:type"]', { static: { property: "og:type" }, set: { content: "website" } });
    upsert('meta[property="og:url"]', { static: { property: "og:url" }, set: { content: `${BASE}${pathname}` } });
    upsert('meta[name="twitter:card"]', { static: { name: "twitter:card" }, set: { content: "summary_large_image" } });

    document.head.querySelectorAll("link[data-hreflang]").forEach((el) => el.remove());
    const rest = pathname.replace(/^\/(fr|en)/, "") || "";
    [["fr", `/fr${rest}`], ["en", `/en${rest}`], ["x-default", `/fr${rest}`]].forEach(([hl, p]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hl;
      link.href = `${BASE}${p}`;
      link.setAttribute("data-hreflang", "true");
      document.head.appendChild(link);
    });
    const canonical = document.head.querySelector('link[rel="canonical"]') || Object.assign(document.createElement("link"), { rel: "canonical" });
    canonical.href = `${BASE}${pathname}`;
    if (!canonical.parentNode) document.head.appendChild(canonical);
  }, [title, description, lang, pathname]);

  return null;
};
